// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"629":"f74b4d04","994":"affa514e"}[chunkId] + ".chunk.js";
};